import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleNavClick = () => {
        // Close mobile menu
        setMenuOpen(false);

        // Manual scroll to top - this ensures it works even on same page
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    };

    // Helper function to determine active class
    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    return (
        <header className={scrolled ? 'scrolled' : ''}>
            <div className="container">
                <nav className="navbar">
                    <Link to="/" className="logo" onClick={handleNavClick}>
                        ZIRAYA<span> Institute</span>
                        {/* <img src="/images/logo.png" alt="ZIRAYA Institute Logo" className="site-logo" /> */}
                    </Link>

                    <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
                        <ul>
                            <li>
                                <Link
                                    to="/"
                                    className={isActive('/')}
                                    onClick={handleNavClick}
                                >
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/about"
                                    className={isActive('/about')}
                                    onClick={handleNavClick}
                                >
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/projects"
                                    className={isActive('/projects')}
                                    onClick={handleNavClick}
                                >
                                    Projects
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/research-journal"
                                    className={isActive('/research-journal')}
                                    onClick={handleNavClick}
                                >
                                    Research Journal
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/workshops-and-training"
                                    className={isActive('/workshops-and-training')}
                                    onClick={handleNavClick}
                                >
                                    Workshops & Training
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/contact"
                                    className={isActive('/contact')}
                                    onClick={handleNavClick}
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="mobile-menu" onClick={toggleMenu}>
                        <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;